import React, { useState, useEffect } from 'react';
import { getStbActivationURL } from '../../Services/StbPartnerService';
import StbMaxError from './StbMaxError';
import StbMaxExpired from './StbMaxExpired';
import { translations } from '../Text/translations';
import hbomaxAppLogo from '../../assets/max/hbomax-applogo.png';
import hbomaxDevices from '../../assets/max/hbomax-devices.png';

const StbMaxNotActivated = ({ currentLang, token }) => {
    const [responseError, setResponseError] = useState(false);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handlePageShow = (event) => {
            if (event.persisted) {
                setLoading(false);
            }
        };

        window.addEventListener('pageshow', handlePageShow);
        return () => {
            window.removeEventListener('pageshow', handlePageShow);
        };
    }, []);

    const handleActivateButtonClick = () => {
        if (!loading) {
            setLoading(true);
            getStbActivationURL(token)
                .then((activationResponse) => {
                    if (activationResponse.responseCode === 'TOKEN_EXPIRED') {
                        setTokenExpired(true);
                        setLoading(false);
                    } else if (activationResponse.responseCode === 'SUCCESS' && activationResponse.url) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            partner: 'hbomax',
                            fsa_type: 'null',
                            click_location: 'qrcode_landing_page',
                            event: 'partner_activation_click'
                        });
                        window.location.href = activationResponse.url;
                    } else {
                        setResponseError(true);
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    setResponseError(true);
                    setLoading(false);
                });
        }
    };

    const handleSupportedDevicesClick = () => {
        const url = currentLang === 'en'
            ? 'https://help.hbomax.com/hk-en/Answer/Detail/000002506'
            : 'https://help.hbomax.com/hk/Answer/Detail/000002506';
        window.open(url, '_blank');
    };

    if (tokenExpired) {
        return <StbMaxExpired currentLang={currentLang} />;
    }

    if (responseError) {
        return <StbMaxError currentLang={currentLang} />;
    }

    return (
        <>
            <div className='message'>
                <h2>{translations[currentLang].stbMaxNotActivatedTitle}</h2>
                <p>
                    {translations[currentLang].maxNotActivated}
                    <br />
                    <br />
                    {translations[currentLang].maxRedirectToMaxRemark}
                </p>
            </div>
            <div className='cta-buttons'>
                <button className='btn primary' onClick={handleActivateButtonClick}>
                    {translations[currentLang].activiateMaxAccount}
                </button>
            </div>

            <p className="onceCompleted">{translations[currentLang].maxOnceCompleted}</p>
            <div className="dlhbomax-wrapper">
                <div className="app">
                    <img src={hbomaxAppLogo} alt="" />
                    <h4>{translations[currentLang].maxDownloadAndWatch}</h4>
                </div>
                <p>{translations[currentLang].maxAvailableDevices}</p>
                <img src={hbomaxDevices} alt="" className="img-devices" />
                <a onClick={handleSupportedDevicesClick} className="link new-window">{translations[currentLang].maxDetailOnSupportedDevices}</a>
                <small>{translations[currentLang].maxSmallNote}</small>
            </div>
        </>
    );
};

export default StbMaxNotActivated;
